export enum OnboardingMilestoneType {
  VERIFY_GMAIL = "verify_gmail",
  SYNC_SENT_MESSAGES = "sync_sent_messages",
  POST_SENT_SYNC_ANALYSIS = "post_sent_sync_analysis",
  SYNC_RECEIVED_MESSAGES = "sync_received_messages",
  ENABLE_FILTERING = "enable_filtering",
  SETUP_COMPLETE = "setup_complete",
}

export enum MilestoneStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface Milestone {
  type: OnboardingMilestoneType;
  sequence: number;
  status: MilestoneStatus;
  metadata?: {
    progressPercent?: number;
    messagesSynced?: number;
    totalToSync?: number;
    elapsedTime?: number;
    error?: string;
    details?: string;
  };
}

export interface OnboardingData {
  status: "pending" | "in_progress" | "completed" | "failed";
  milestones: Milestone[];
}
